import areaList from "../lib/gb_area.json"
import {debug} from "../lib/util";
import {systemService} from "@/services/system";
import storage from "good-storage";

const fArea = (item) => {
  return {label: item[1], value: item[0]}
}

const fList = (code) => {
  return areaList.filter((item) => {
    return item[3] && item[3] === code
  }).map((res) => {
    return fArea(res);
  })
}

async function getList() {
  let list = storage.session.get('areaList') || [];
  if (!list || !list.length) list = await systemService.areaList();
  storage.session.set('areaList', list);
  return list;
}

function generateList(list) {
  if (!list.length) return list;
  return list.map(r => {
    return {
      value: r.areaCode,
      label: r.areaName,
      parentCode: r.parentCode,
      children: generateList(r.subList || [])
    }
  });
}

function findArea(list, value, ans = []) {
  if (!value) return null;
  for (let i = 0; i < list.length; i++) {
    const area = list[i];
    ans = [...ans, {...area}];
    // console.log('find area', area.label, area.value, ans.map(r => r.label));
    if (area.value == value) {
      return ans;
    }
    const result = findArea(area.children, value, ans);
    // console.log('result', result);
    if (result && result.length) {
      return result;
    }
    ans.pop();
  }
  return null
}


/**
 *
 * @param res 不为空则返回查询结果
 * @param {'code'|'text'} type
 * @returns {Promise<string|*[]>}
 */
export default async (res = null, type = "code") => {
  const list = await getList();
  let ans = generateList(list);
  console.log('格式化的地区列表', ans);
  if (!res) return ans;
  else {
    console.log('res,type', res, type);
    const result = findArea(ans, res, []);
    console.log('result', result);
    if (type === 'code') {
      return result.map(r => r.value);
    } else if (type === 'text') {
      return result.map(r => r.label).join(' ');
    } else
      return result;
  }


  /*let data = [];
  areaList.forEach((area) => {
    if (!area[3]) {
      data.push(fArea(area));
    }
  });

  if (res) {
    let ret = [];
    while (true) {
      let index = areaList.findIndex((item) => {
        return item[0] == res
      });
      let area = areaList[index];
      ret.push(fArea(area));
      if (area[3]) {
        res = area[3];
      } else {
        break;
      }
    }
    ret = ret.reverse();
    if (type == "code") {
      return ret.map((res) => {
        return res.value;
      })
    } else if (type == "text") {
      debug("ret", ret);
      return ret.map((res) => {
        return res.label
      }).join(" ");
    } else {
      return ret;
    }
  }

  //debug('area', data);
  return data.map((item) => {
    let children = fList(item.value);
    children = children.map((res) => {
      res.children = fList(res.value)
      return res;
    })
    item.children = children;
    return item;
  });*/
}



// WEBPACK FOOTER //
// ./src/utils/formatArea.js